import { useEffect } from "react";
import { COMPANY } from "@/data/content";
import { FAQS } from "@/data/content";

const SITE_URL = "https://honeybeeroofers.com";

export default function Seo() {
  useEffect(() => {
    document.title =
      "Roof Repair & Replacement | Snohomish, Skagit, and King County";

    const setMeta = (attr, key, content) => {
      let el = document.head.querySelector(`meta[${attr}="${key}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };

    const desc =
      "Honey Bee Roofing & Exteriors — Everett, WA based roofing contractor serving Snohomish, King & Skagit County. Residential & commercial roofing, storm & wind damage, decks, siding & windows. Flat-rate pricing, 50-year CertainTeed guarantee.";
    setMeta("name", "description", desc);
    setMeta("name", "keywords",
      "roof repair Snohomish County, roof replacement Everett WA, best roofing company Arlington WA, commercial roofing contractor Everett WA, licensed roofing contractor WA, roof leak repair, storm damage roof repair, TPO roofing Snohomish County, roofing contractor near me 425, roofers Marysville WA");
    setMeta("property", "og:title", "HoneyBee Roofers | Snohomish, King & Skagit County Roofing");
    setMeta("property", "og:description", desc);
    setMeta("property", "og:type", "website");
    setMeta("property", "og:url", SITE_URL);

    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) { canonical = document.createElement("link"); canonical.setAttribute("rel", "canonical"); document.head.appendChild(canonical); }
    canonical.setAttribute("href", SITE_URL);

    const ld = {
      "@context": "https://schema.org",
      "@type": "RoofingContractor",
      name: COMPANY.name,
      image: `${SITE_URL}/honeybee-logo.svg`,
      "@id": SITE_URL,
      url: SITE_URL,
      telephone: COMPANY.phone,
      priceRange: "$$",
      areaServed: [
        "Snohomish County WA", "King County WA", "Skagit County WA",
        "Arlington WA", "Marysville WA", "Everett WA", "Lake Stevens WA",
        "Snohomish WA", "Monroe WA", "Seattle WA",
      ],
      address: {
        "@type": "PostalAddress",
        streetAddress: "118 SE Everett Mall Way",
        addressLocality: "Everett",
        addressRegion: "WA",
        postalCode: "98208",
        addressCountry: "US",
      },
      makesOffer: [
        "Residential Roof Replacement", "Storm Damage Repair", "Commercial Roofing",
        "Roof Leak Repair", "Roof Inspection", "Siding & Exteriors",
      ].map((s) => ({ "@type": "Offer", itemOffered: { "@type": "Service", name: s } })),
      aggregateRating: {
        "@type": "AggregateRating",
        ratingValue: "5.0",
        reviewCount: "7",
      },
    };

    const faqLd = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: FAQS.map((f) => ({
        "@type": "Question",
        name: f.q,
        acceptedAnswer: { "@type": "Answer", text: f.a },
      })),
    };

    let script = document.getElementById("ld-json");
    if (!script) {
      script = document.createElement("script");
      script.id = "ld-json";
      script.type = "application/ld+json";
      document.head.appendChild(script);
    }
    script.textContent = JSON.stringify([ld, faqLd]);
  }, []);

  return null;
}
